import { action, thunk } from 'easy-peasy';
import { ProductStoreModel } from './types';
import { getProductList } from '../../api/products';
import handleError from '../../api/apiErrorHandle';
import toPagedRequest from '../../services/pagedRequestService';
import {
  getPaginationLimit, PaginationScreenKey, PRODUCTS_DEFAULT_LIMIT,
} from '../../services/paginationLimitService';
import createLatestRequestSignal from '../../services/latestRequestSignalService';

const nextProductListSignal = createLatestRequestSignal();

const productStore: ProductStoreModel = {
  loading: false,
  products: [],
  total: 0,
  apiGroup: undefined,
  currentFilter: {
    page: 1,
    orderBy: 'id',
    orderDirection: 'asc',
    filter: {
      brands: [],
      suppliers: [],
      states: [],
      categories: [],
      eshopIds: [],
      additionalMarketplaceCodes: [],
      holdStatuses: [],
    },
  },

  fetchProducts: thunk(async (actions, payload) => {
    const signal = nextProductListSignal();

    actions.setLoading(true);
    try {
      const { data } = await getProductList(payload.apiGroup, payload.request, signal);

      actions.setProducts({ total: data.total, products: data.data });
    } catch (error) {
      handleError(error);
    } finally {
      if (!signal.aborted) {
        actions.setLoading(false);
      }
    }
  }),
  reloadProducts: thunk(async (actions, _, { getState }) => {
    const { apiGroup, currentFilter } = getState();
    if (!apiGroup) {
      return;
    }

    const limit = getPaginationLimit(PaginationScreenKey.PRODUCTS, PRODUCTS_DEFAULT_LIMIT);

    await actions.fetchProducts({ apiGroup, request: toPagedRequest(currentFilter, limit) });
  }),
  setProducts: action((state, payload) => {
    state.total = payload.total;
    state.products = payload.products;
  }),
  setLoading: action((state, payload) => {
    state.loading = payload;
  }),
  setFilter: action((state, payload) => {
    state.currentFilter = payload;
  }),
  setApiGroup: action((state, payload) => {
    state.apiGroup = payload;
  }),
};

export default productStore;
